/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Today_WeekInputs */

const en_us2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}`)
};

const pt_br2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const es_419_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const pt_pt2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const fr_fr2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week}`)
};

const de_de2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week}`)
};

const it_it2_today_week = /** @type {(inputs: Today_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week}`)
};

/**
* | output |
* | --- |
* | "Week {week}" |
*
* @param {Today_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_week = /** @type {((inputs: Today_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_week(inputs)
	if (locale === "es-419") return es_419_today_week(inputs)
	if (locale === "pt-PT") return pt_pt2_today_week(inputs)
	if (locale === "fr-FR") return fr_fr2_today_week(inputs)
	if (locale === "de-DE") return de_de2_today_week(inputs)
	if (locale === "it-IT") return it_it2_today_week(inputs)
	return en_us2_today_week(inputs)
});
export { today_week as "today.week" }